import { FC } from 'react'
import styled from 'styled-components'
import { Box } from '@ucheba/ui/components/Box/desktop'
import { Grid, GridCol } from '@ucheba/ui/components/Grid/desktop'
import RestartIcon from '@ucheba/ui/icons/icon__restart.svg'
import { Text } from '@ucheba/ui/components/Text/desktop'
import { IOddsAssessmentResultButton } from '../types'
import {
  EAssessmentColorBg,
  EAssessmentColorText,
  EAssessmentText,
} from '../components/OddsAssessmentResults/types'

const Block = styled(Box)`
  cursor: pointer;
  position: relative;
`

const RestartIconBlock = styled.div`
  position: absolute;
  top: 8px;
  right: 8px;
`

const OddsAssessmentResultButton: FC<IOddsAssessmentResultButton> = (props) => {
  const { onReset, probability, onClick } = props

  return (
    <Block spacing='xsmall' color={EAssessmentColorBg[probability]} onClick={onClick}>
      <Grid spacing='xxsmall' justifyContent='space-between'>
        <GridCol uxs={22} shrink='1'>
          <Text
            fontSize='h4'
            lineHeight='h4'
            fontWeight='extrabold'
            firstLetterUppercase
            color={EAssessmentColorText[probability]}
          >
            {`${EAssessmentText[probability]} шансы поступить`}
          </Text>
        </GridCol>
      </Grid>

      <RestartIconBlock>
        <RestartIcon
          width='16px'
          height='16px'
          onClick={(e) => {
            e.stopPropagation()

            onReset()
          }}
        />
      </RestartIconBlock>
    </Block>
  )
}

export default OddsAssessmentResultButton
